import PlanList from '@/views/plan/PlanList'

const prefix = '/'

export const PlansRoutesPath = Object.freeze({
  LISTAR: {
    path: prefix,
    title: 'plans.routeTitle',
    name: 'planList',
    component: PlanList,
    props: true
  }
})

export default Object.values(PlansRoutesPath)
